const trimTrailingSlash = (value) => value.replace(/\/+$/, '');
const trimApiSuffix = (value) => value.replace(/\/api$/i, '');

export function getApiBaseUrl() {
  const raw = (process.env.REACT_APP_API_BASE_URL || '').trim();
  const isProd = process.env.NODE_ENV === 'production';

  if (raw) {
    const lower = raw.toLowerCase();
    // Never allow localhost API targets in production bundles.
    if (
      isProd &&
      (lower.includes('localhost') || lower.includes('127.0.0.1') || lower.includes('0.0.0.0'))
    ) {
      console.warn('Ignoring localhost REACT_APP_API_BASE_URL in production. Falling back to same-origin /api.');
      return '';
    }

    // Accept only absolute http(s) URLs or root-relative paths.
    if (raw.startsWith('http://') || raw.startsWith('https://') || raw.startsWith('/')) {
      const normalized = trimApiSuffix(trimTrailingSlash(raw));
      return normalized === '/' ? '' : normalized;
    }
    // Ignore malformed values like "localhost:5000" (missing protocol).
    console.warn('Ignoring invalid REACT_APP_API_BASE_URL. Falling back to default API base.');
  }

  return process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : '';
}
